import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './components/ThemeProvider'
import LandingPage from './components/LandingPage'
import LoginPage from './pages/LoginPage'
import SignupPage from './pages/SignupPage'
import DashboardPage from './pages/DashboardPage'
import APIKeyPage from './pages/APIKeyPage'
import BatchPage from './pages/BatchPage'
import AnalyticsPage from './pages/AnalyticsPage'
import IntegrationsPage from './pages/IntegrationsPage'
import SettingsPage from './pages/SettingsPage'
import APIDocsPage from './pages/APIDocsPage'
import BillingPage from './pages/BillingPage'
import AboutPage from './pages/AboutPage'
import HowToUsePage from './pages/HowToUsePage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsOfServicePage from './pages/TermsOfServicePage'
import AdminPage from './pages/AdminPage'
import MakePage from './pages/MakePage'
import TTSPage from './components/TTSPage'
import SeoAuditPage from './pages/SeoAuditPage'
import ShopifyPricingPage from './pages/ShopifyPricingPage'
import BlogGeneratorPage from './pages/BlogGeneratorPage'
import BlogPage from './pages/BlogPage'
import BlogPostPage from './pages/BlogPostPage'
import IndexingPage from './pages/IndexingPage'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/docs" element={<APIDocsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/how-to-use" element={<HowToUsePage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/make" element={<MakePage />} />
          <Route path="/atg/pricing" element={<ShopifyPricingPage />} />
          <Route path="/auth/login" element={<LoginPage />} />
          <Route path="/auth/signup" element={<SignupPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/api-key"
            element={
              <ProtectedRoute>
                <APIKeyPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/batch"
            element={
              <ProtectedRoute>
                <BatchPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/tts"
            element={
              <ProtectedRoute>
                <TTSPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/blog-generator"
            element={
              <ProtectedRoute>
                <BlogGeneratorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/seo-audit"
            element={
              <ProtectedRoute>
                <SeoAuditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/indexing"
            element={
              <ProtectedRoute>
                <IndexingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/analytics"
            element={
              <ProtectedRoute>
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/integrations"
            element={
              <ProtectedRoute>
                <IntegrationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/billing"
            element={
              <ProtectedRoute>
                <BillingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App

